import Swiper from "swiper";
import { Autoplay, A11y, EffectFade, Pagination } from "swiper/modules";

/**
 * Initializes all Swiper sliders on the page.
 */
export function initializeHeroSlideshow(): void {
  document.addEventListener("DOMContentLoaded", () => {
    const slideshows: NodeListOf<Element> =
      document.querySelectorAll(".js-slideshow");

    slideshows.forEach((slideshow) => {
      if (slideshow instanceof HTMLElement) {
        const swiperAutoPlayOptions = slideshow.dataset.autoplayOptions
          ? JSON.parse(slideshow.dataset.autoplayOptions)
          : { autoplay: false };

        new Swiper(slideshow, {
          loop: true,
          modules: [Autoplay, A11y, EffectFade, Pagination],
          slidesPerView: 1,
          a11y: {
            enabled: true,
          },
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          ...swiperAutoPlayOptions,
        });
      }
    });
  });
}
